﻿import bootbox from 'bootbox';

export function yesNoCancelDialog(title, message, includeCancelButton, callback) {

    var dialogOptions = {
        //height: DialogHeight,
        //width: DialogWidth,
        title: title,
        message: message,
        buttons: {
            Yes: {
                label: "Yes",
                className: "btn-primary",
                callback: function () { callback(true); }
            },
            No: {
                label: "No",
                className: "btn-default",
                callback: function () { callback(false); }
            }
        }
    };

    if (includeCancelButton) {
        dialogOptions.buttons["Cancel"] = {
            label: "Cancel",
            className: "btn-default",
            callback: function () { callback(undefined) }
        };
    }

    bootbox.dialog(dialogOptions);
}

export function confirmDialog(title, message, callback) {
    /* Type 1: Normal messages (small)...., Type 2: Info (large)....   */
    var DialogHeight = 200;
    var DialogWidth = 300;

    /* NB! 'opacity' set in Site.scss: .ui-widget-overlay { */
    bootbox.dialog({
        height: DialogHeight,
        width: DialogWidth,
        title: title,
        message: message,
        buttons: {
            OK: {
                label: "OK",
                className: "btn-primary",
                callback: function () {
                    callback(true);
                }
            },
            Cancel: {
                label: "Cancel",
                className: "btn-default",
                callback: function () {
                    callback(false);
                }
            }
        }
    });
}

export function infoDialog(textObject) {
    var DialogHeight, DialogWidth;

    if (textObject.DialogHeight == null) {
        DialogHeight = 200;
    } else {
        DialogHeight = textObject.DialogHeight;
    }
    if (textObject.DialogWidth == null) {
        DialogWidth = 300;
    } else {
        DialogWidth = textObject.DialogWidth;
    }
    /* NB! 'opacity' set in Site.scss: .ui-widget-overlay  */
    var divDialog = $('<div/>');

    if (textObject.Introduction != null && textObject.Introduction != "") {
        divDialog.append($("<p />").append(textObject.Introduction));
    }
    for (var i = 0; i < textObject.Texts.length; i++) {
        if (textObject.Texts[i].Title != null && textObject.Texts[i].Title != "") {
            divDialog.append($("<h4 />").append(textObject.Texts[i].Title));
        }
        if (textObject.Texts[i].Text != null && textObject.Texts[i].Text != "") {
            divDialog.append($("<p />").append(textObject.Texts[i].Text));
        }
    }
    bootbox.dialog({
        height: DialogHeight,
        width: DialogWidth,
        title: textObject.Title,
        message: divDialog,
        modal: true,
        buttons: {
            OK: {
                label: "OK",
                className: "btn-primary",
                callback: function () {
                }
            }
        }
    });
}

// This is called from Portfolio.js
export function messageDialog(title, message, DialogHeight, DialogWidth, callback) {
    /* Type 1: Normal messages (small)...., Type 2: Info (large)....   */

    if (DialogHeight == null) {
        DialogHeight = 200;
    }
    if (DialogWidth == null) {
        DialogWidth = 300;
    }

    /* NB! 'opacity' set in Site.scss: .ui-widget-overlay */
    bootbox.dialog({
        height: DialogHeight,
        width: DialogWidth,
        title: title,
        closeButton: false,
        message: message,
        buttons: {
            OK: {
                label: "OK",
                className: "btn-primary",
                callback: function () {
                    if (typeof (callback) == "function") callback();
                }
            }
        }
    });

    // Frank: return
}

export function inputDialog(title, message, callback) {
    var dialog = bootbox.dialog({
        title: title,
        message: "<p>" + message + "</p><input type='text' class='form-control input-sm'/>",
        buttons: {
            OK: function () {
                if (typeof (callback) == "function") {
                    callback($(dialog).find("input").val());
                }
            }
        }
    });
}

export function groupPublishDialog(callback, groupSharingData) {
    var SharedWithGroupId = groupSharingData && groupSharingData.SharedWithGroup ? parseInt(groupSharingData.SharedWithGroup) : null;
    if (isNaN(SharedWithGroupId)) {
        SharedWithGroupId = null;
    }

    var historicalCopyDate = groupSharingData.Updated;

    var generatedListHtml = '<select name="groupWhereToPublish" id="group-where-to-publish">';
    if (groupSharingData && groupSharingData.OPGroups) {
        generatedListHtml += '<optgroup label="Owning groups">';
        groupSharingData.OPGroups.forEach(group => {
            var selectedOption = group.Id === SharedWithGroupId ? 'selected' : '';
            generatedListHtml += '<option ' + selectedOption + ' value="' + group.Id + '">' + group.Name + '</option>';
        });
    }

    if (groupSharingData && groupSharingData.MembershipGroups) {
        generatedListHtml += '<optgroup label="Membership groups">';
        groupSharingData.MembershipGroups.forEach(group => {
            var selectedOption = group.Id === SharedWithGroupId ? 'selected' : '';
            generatedListHtml += '<option ' + selectedOption + ' value="' + group.Id + '">' + group.Name + '</option>';
        });
    }

    generatedListHtml += '</select>';

    var comment = groupSharingData && groupSharingData.GroupSharedComment ? groupSharingData.GroupSharedComment : '';
    var link = groupSharingData && groupSharingData.GroupSharedLink ? groupSharingData.GroupSharedLink : '';
    var readonly = groupSharingData && groupSharingData.GroupSharedReadOnly ? 'checked' : '';
    

    var formHtml = "<script>function linkValidationFunction (e) { \
    var value = e.target.value;\
    value = value.trim();\
    var showNotification = false;\
    if (value && value.length > 0) {\
        var isHttpUrl = value.indexOf(\"http://\") == 0;\
        var isHttpsUrl = value.indexOf(\"https://\") == 0;\
        if (!((isHttpUrl && value.length > 8) || (isHttpsUrl && value.length > 9))) showNotification = true;\
    }\
    if (showNotification){\
        $(\"#link_validation_message\").show();\
    }else $(\"#link_validation_message\").hide();\
    }</script><form id='publish_dialog' action=''>\
    <h3>Group sharing</h3><hr>\
    <h4>Select group where analysis will be available</h4>" + generatedListHtml + "<br/>\
    <input style=\"margin-top: 1.5rem\" name=\"readonly\" id=\"readonly\" type=\"checkbox\" " + readonly + " /> <h4 style=\"display: inline\">Read only</h4> <br />\
    <h4> Comment</h4><input style='width:100%' id='comment' type='text' name='comment' value='" + comment + "' /><br/><br/>\
    <h4>Link</h4><input style='width:100%' id='link' type='text' name='link' value='" + link +"' oninput='linkValidationFunction(event)' /><p style='color: red; margin-top: 2px' hidden id='link_validation_message'>Link is not valid! Please type full link, including https:// or http://</p>\
    </form><br /><span>(Published analysis uses the historical copy)</span>";
    if (groupSharingData && groupSharingData.SharedWithGroup != null) {
        formHtml += "<br /><span>Historical copy last updated: " + historicalCopyDate + "</span>";
        formHtml += "<br /><button class=\"btn btn-primary\" id=\"update-shared-analysis-copy\">Update the shared analysis</button> <br /> <button class=\"btn btn-danger mt-2\" id=\"remove-group-sharing\">Remove group sharing</button>";
    }
    bootbox.confirm(formHtml, function (result) {
        if (result) {
            var publishToGroup = parseInt($("#group-where-to-publish").val());
            var comment = $('#comment').val();
            var link = $('#link').val();
            var readonly = $('#readonly').prop('checked');
            if (link) {
                link = link.trim();
                var isHttpUrl = link.indexOf("http://");
                var isHttpsUrl = link.indexOf("https://");
                if (!((isHttpUrl && link.length > 8) || (isHttpsUrl && link.length > 9))) {
                    alert('Link is not valid! Please type full link, including https:// or http://');
                    callback(false);
                    return;
                }
            }

            if (isNaN(publishToGroup) || (publishToGroup === 0)) {
                alert('Selected group is not valid');
                callback(false);
                return;
            }

            callback(true, publishToGroup, comment, link, readonly);
        } else {
            callback(false);
        }
    });
}

export function publishDialog(callback) {
    var formHtml = "<script>function linkValidationFunction (e) { \
    var value = e.target.value;\
    value = value.trim();\
    var showNotification = false;\
    if (value && value.length > 0) {\
        var isHttpUrl = value.indexOf(\"http://\") == 0;\
        var isHttpsUrl = value.indexOf(\"https://\") == 0;\
        if (!((isHttpUrl && value.length > 8) || (isHttpsUrl && value.length > 9))) showNotification = true;\
    }\
    if (showNotification){\
        $(\"#link_validation_message\").show();\
    }else $(\"#link_validation_message\").hide();\
    }</script><form id='publish_dialog' action=''>\
    <h3>a) Create a public shareable link</h3><hr>\
    <p>The analysis will be accessible to everyone with access to the link.</p>\
    <p>Click the Ok button to create a public shareable link.</p>\
    <p>Important! If you only want to create a shareable link and do not want to publish the analysis - Then do not input a comment below.</p><br/>\
    <h3>b) Publish the analysis</h3>\
    <p>A published analysis will be available to everyone with access to this website.</p>\
    <p>If you want to Publish the analysis on this website - Then Input a comment below and click the Ok button. The comment will be shown, and will be searchable for the other Users.</p >\
    <p>Comment (needed to publish and for search):</p><input style='width:100%' id='comment' type='text' name='comment' /><br/>\
    <p>Link (e.g. https://www.simulationfinance.com):</p><input style='width:100%' id='link' type='text' name='link' oninput='linkValidationFunction(event)' /><p style='color: red; margin-top: 2px' hidden id='link_validation_message'>Link is not valid! Please type full link, including https:// or http://</p>\
    </form>";

    bootbox.confirm(formHtml, function (result) {
            if (result) {
                var comment = $('#comment').val();
                var link = $('#link').val();
                if (link) {
                    link = link.trim();
                    var isHttpUrl = link.indexOf("http://");
                    var isHttpsUrl = link.indexOf("https://");
                    if (!((isHttpUrl && link.length > 8) || (isHttpsUrl && link.length > 9))) {
                        alert('Link is not valid! Please type full link, including https:// or http://');
                        callback(false);
                        return;
                    }
                }
                callback(true, comment, link);
            } else {
                callback(false);
            }   
    });    

}

export function manageFeaturesDialog(companyId) {
    $.ajax({
        url: Router.action("Portfolio", "ManageFeatures", { area: "Corp" }),
        data: { CompanyId: companyId },
        method: "GET",
        success: function (data) {
            var dialogContent = $('<div style="display: block"></div>');
            dialogContent.append(data);

            bootbox.dialog({
                title: 'Manage your Input menu',
                message: dialogContent.html(),
                buttons: {
                    Save: {
                        label: "Save",
                        className: "btn btn-primary",
                        callback: function (e) {
                            var target = e.target || e.srcElement;
                            var parent = $(target).closest(".modal-dialog");
                            var form = parent.find("form");
                            form.find("#CompanyId").val(companyId);

                            $.ajax({
                                type: 'POST',
                                url: form.attr("action"),
                                data: form.serialize(),
                                success: function () {
                                    alertSuccess('Saved');
                                    location.reload();
                                },
                                error: function (err) {
                                    alertError('Failed');
                                }
                            }); 
                        }
                    },
                    Close: {
                        label: "Close",
                        className: "btn btn-default"
                    }
                }
            });
        }
    });
}

// PS! Increases nr of text in this function
// function loadingDialog(element, durIn, durOut, opacity, message, subText1, callback) {
export function loadingDialog(element, durIn, durOut, opacity, Mainmessage, message, subText1, subText2, subText3, callback) {
    var finished = false;
    if (opacity == null) opacity = 1;
    $(element).css("opacity", 0);

    if (Mainmessage != null) {
        $(element).find("h1").text(Mainmessage);
    } else {
        $(element).find("h1").text("");
    }

    if (message != null) {
        $(element).find("h2").text(message);
    } else {
        $(element).find("h2").text("");
    }

    if (subText1 != null) {
        $(element).find("h3").text(subText1);
    } else {
        $(element).find("h3").text("");
    }

    if (subText2 != null) {
        $(element).find("h4").text(subText2);
    } else {
        $(element).find("h4").text("");
    }

    if (subText3 != null) {
        $(element).find("h5").text(subText3);
    } else {
        $(element).find("h5").text("");
    }

    $(element).show(function () {
        $(element).animate({ opacity: opacity }, { duration: durIn }).promise().done(function () {
            setTimeout(function () {
                if (!finished) {
                    $(element).find("img").fadeIn();
                }
            }, 400);
            callback(function (callback2) {
                finished = true;
                $(element).find("img").fadeOut();
                $(element).animate({ opacity: 0.0 }, {
                    duration: durOut,
                    complete: function () {
                        $(element).hide();
                        $("ul.locked").removeClass("locked");
                        if (typeof (callback2) == "function") {
                            callback2();
                        }
                    }
                });
            });
        });
    });
}

export function alertSuccess(message) {
    var Alert = $("<div />");
    Alert.attr("style", "display: none; position: fixed; top: 120px; right: 50px; z-index: 30; ");
    Alert.addClass("alert alert-success alert-dismissable");
    Alert.html(message);
    Alert.append("<button type=\"button\" class=\"close\" data-dismiss=\"alert\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button>");
    $("body").append(Alert);
    Alert.fadeIn(200, function () {
        setTimeout(function () {
            Alert.fadeOut(500, function () {
                Alert.remove();
            });
        }, 2000);
    });
}

export function alertError(message) {
    var Alert = $("<div />");
    Alert.attr("style", "display: none; position: fixed; top: 120px; right: 50px; z-index: 30; ");
    Alert.addClass("alert alert-danger alert-dismissable");
    Alert.html(message);
    Alert.append("<button type=\"button\" class=\"close\" data-dismiss=\"alert\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button>");
    $("body").append(Alert);
    Alert.fadeIn(200, function () {
        setTimeout(function () {
            Alert.fadeOut(500, function () {
                Alert.remove();
            });
        }, 2000);
    });
}

export function alertOffline(callback) {
    //var text = $("<p><strong>Your session will timeout in <span>" + count + "</span> seconds...<a href='#' id='keep-alive' class='pull-right' style='color: inherit;'  >Keep alive</a></strong></p>");
    //var alert2 = $("<div role='alert' style='position: absolute; top: 0; width: 70%; left: 50%; z-index: 6;' />");
    //var alert3 = $("<div class='alert alert-warning' style='display: none; width: 100%; position: relative; left: -50%;' />");
    var Alert = $("<div />");
    var Alert2 = $("<div />");
    Alert2.attr("style", 'display: none; width: 100%; position: relative; left: -50%;');
    Alert2.addClass("alert alert-warning alert-dismissable");
    Alert.attr("style", "position: absolute; top: 0; width: 70%; left: 50%; z-index: 30;");
    Alert.attr("role", "alert");
    Alert2.html("<strong>Page offline, please check your connection.</strong>");
    Alert2.append("<button type=\"button\" class=\"close\" data-dismiss=\"alert\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button>");
    Alert.html(Alert2);
    $("body").append(Alert);
    Alert2.slideDown(500, function () {
        callback(function () {
            Alert2.slideUp(500, function () {
                Alert.remove();
            });
        });
    });
}

export function alertWarning(message) {
    var Alert = $("<div />");
    Alert.attr("style", "display: none; position: fixed; top: 120px; right: 50px; z-index: 30; ");
    Alert.addClass("alert alert-warning alert-dismissable");
    Alert.html(message);
    Alert.append("<button type=\"button\" class=\"close\" data-dismiss=\"alert\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button>");
    $("body").append(Alert);
    Alert.fadeIn(200, function () {
        setTimeout(function () {
            Alert.fadeOut(500, function () {
                Alert.remove();
            });
        }, 2000);
    });
}

export function alertInfo(message) {
    var Alert = $("<div />");
    Alert.attr("style", "display: none; position: fixed; top: 120px; right: 50px; z-index: 30; ");
    Alert.addClass("alert alert-info alert-dismissable");
    Alert.html(message);
    Alert.append("<button type=\"button\" class=\"close\" data-dismiss=\"alert\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button>");
    $("body").append(Alert);
    Alert.fadeIn(200, function () {
        setTimeout(function () {
            Alert.fadeOut(500, function () {
                Alert.remove();
            });
        }, 2000);
    });
}

export function loadDataFromExcelDialog(contr, method, area, companyId) {
    $.ajax({
        url: Router.action("LoadDataFromExcel", "LoadDataFromExcel"),
        data: { Contr: contr, Method: method, Area: area, CompanyId: companyId },
        method: "GET",
        success: function (data) {
            let dialogContent = $(`<div style="display: block">
                                    <div id = "loading-spinner" style = "text-align: center" hidden >
                                        <p id="output-info-first-line">Please wait for a moment while we create and calculate your analysis</p>
                                        <br/>
                                        <p id="output-info" hidden>After this window has been closed you can select output in the top-left drop down lists</p>
                                        <br/>
                                        <p id="historic-redirect" hidden>You will be redirected to the screen with historic data input</p>
                                        <br/>
                                        <img src="/Content/images/ajax-spinner.gif" width="64px" height="64px" />
                                    </div>
                                   </div>`);
            dialogContent.append(data);

            bootbox.dialog({
                title: 'Load data from Excel',
                message: dialogContent.html(),
                buttons: {
                    Save: {
                        label: "Save",
                        className: "btn btn-primary",
                        callback: function (e) {
                            const target = e.target || e.srcElement;
                            const parent = $(target).closest(".modal-dialog");
                            const form = parent.find("form");
                            form.find("#CompanyId").val(companyId);
                            const formData = new FormData(form[0]);
                            loadingDialog(".body-overlay", 500, 2000, 1, "Uploading the file", "Please wait a few moments...", null, null, null, function (callback) { });

                            $.ajax({
                                type: 'POST',
                                url: form.attr("action"),
                                data: formData,
                                processData: false,
                                contentType: false,
                                success: function (data) {
                                    let message = "The analysis has been created successfully!";

                                    if (data && data.Message) {
                                        message = data.Message;
                                        if (data.NewCompanyId) {
                                            companyId = data.NewCompanyId;
                                        }
                                    }
                                    $(".body-overlay").hide();
                                    messageDialog('Success!', message, 200, 200, () => {
                                        loadingDialog(".body-overlay", 500, 2000, 1, "Navigating to the analysis", "Please wait a few moments...", null, null, null, function (callback) { });
                                        if (data.Url)
                                            location = data.Url
                                        else
                                            location = "/Corp/l/" + companyId;
                                    });
                                },
                                error: function (err) {
                                    let errorMessage = "Creating the analysis has failed!";
                                    if (err && err.responseJSON && err.responseJSON.Error) {
                                        errorMessage = err.responseJSON.Error;
                                    }
                                    $(".body-overlay").hide();
                                    messageDialog('Error', errorMessage, 200, 200, () => { bootbox.hideAll();});                                   
                                }
                            });
                            bootbox.hideAll();
                            return false;
                        }
                    },
                    Close: {
                        label: "Close",
                        className: "btn btn-default"
                    }
                }
            });
        },
        error: function (err) {
            console.log(err);
        }
    });
}

